(function () {
  function initBundles(sectionId, productId) {
    var root = document.getElementById('jollyBundles-' + sectionId);
    if (!root) return;
    var form = document.getElementById('product-form-' + productId);
    var idInput = form && form.querySelector('input[name="id"]');

    // Create or get hidden quantity input in the form
    var hiddenQuantityInput =
      form && form.querySelector('input[name="quantity"]');
    if (!hiddenQuantityInput && form) {
      hiddenQuantityInput = document.createElement('input');
      hiddenQuantityInput.type = 'hidden';
      hiddenQuantityInput.name = 'quantity';
      hiddenQuantityInput.value = '1';
      hiddenQuantityInput.setAttribute('data-bundle-quantity-hidden', '');
      form.appendChild(hiddenQuantityInput);
    }

    function selectPack(pack) {
      var packs = root.querySelectorAll('variant-pack');
      for (var i = 0; i < packs.length; i++) {
        packs[i].classList.remove('selected');
        var sq = packs[i].querySelector('.variant-pack-size-quantity');
        if (sq) sq.style.display = 'none';
      }
      pack.classList.add('selected');
      var sqSel = pack.querySelector('.variant-pack-size-quantity');
      if (sqSel) sqSel.style.display = '';

      // Reset quantity selector for the selected pack
      resetQuantitySelector(pack);

      // Check if size is selected and update button states
      checkSizeSelection(pack);

      updateVariantFromPack(pack);
    }

    function resetQuantitySelector(pack) {
      var qtySelector = pack.querySelector('jolly-quantity-selector');
      if (!qtySelector) return;

      var input = qtySelector.querySelector(
        'input[data-bundle-quantity-input]'
      );
      var minusBtn = qtySelector.querySelector(
        ".quantity__button[name='minus']"
      );
      var plusBtn = qtySelector.querySelector(".quantity__button[name='plus']");

      if (input) {
        // Reset to value 1
        input.value = '1';
      }

      // Update button states
      if (minusBtn) {
        var min = parseInt(input.min) || 1;
        if (parseInt(input.value) <= min) {
          minusBtn.classList.add('disabled');
        } else {
          minusBtn.classList.remove('disabled');
        }
      }

      if (plusBtn) {
        var max = parseInt(input.max) || 9999;
        if (parseInt(input.value) >= max) {
          plusBtn.classList.add('disabled');
        } else {
          plusBtn.classList.remove('disabled');
        }
      }

      // Sync hidden quantity input
      syncHiddenQuantityInput(pack);
    }

    function syncHiddenQuantityInput(pack) {
      if (!hiddenQuantityInput) return;

      var qtySelector = pack.querySelector('jolly-quantity-selector');
      if (!qtySelector) return;

      var input = qtySelector.querySelector(
        'input[data-bundle-quantity-input]'
      );
      if (input) {
        hiddenQuantityInput.value = input.value;
      }
    }

    function setButtonsDisabled(disabled) {
      if (!form) return;

      // Get add to cart button
      var atcBtn = form.querySelector('.add-to-cart-btn');

      // Get just pay button
      var justBtn =
        form.querySelector('just-pay-button') ||
        document.querySelector('just-pay-button');

      if (disabled) {
        if (atcBtn) atcBtn.classList.add('disabled-no-size');
        if (justBtn) justBtn.classList.add('disabled-no-size');
      } else {
        if (atcBtn) atcBtn.classList.remove('disabled-no-size');
        if (justBtn) justBtn.classList.remove('disabled-no-size');
      }
    }

    function checkSizeSelection(pack) {
      // Check if pack has size options
      var hasSizeOptions = !!pack.querySelector('.jbb-variant-map [data-size]');
      if (!hasSizeOptions) {
        // No size options, enable buttons
        setButtonsDisabled(false);
        return true;
      }

      // Check if a size is selected
      var sizeLabel = pack.querySelector('[data-option-dropdown-value]');
      var chosenSize = sizeLabel ? (sizeLabel.textContent || '').trim() : '';

      if (
        !chosenSize ||
        /choisis ta taille|choose your size/i.test(chosenSize)
      ) {
        // No size selected, disable buttons
        setButtonsDisabled(true);
        return false;
      }

      // Size selected, enable buttons
      setButtonsDisabled(false);
      return true;
    }

    function currentPack() {
      return (
        root.querySelector('variant-pack.selected') ||
        root.querySelector('variant-pack')
      );
    }

    function updateDropdownLabel(dropdown, text) {
      var valueSpan =
        dropdown && dropdown.querySelector('[data-option-dropdown-value]');
      if (valueSpan) valueSpan.textContent = text;
    }

    function updateVariantFromPack(pack) {
      if (!form || !idInput) return;
      var sizeLabel = pack.querySelector('[data-option-dropdown-value]');
      var chosenSize = sizeLabel ? (sizeLabel.textContent || '').trim() : '';
      var hasSizeOptions = !!pack.querySelector('.jbb-variant-map [data-size]');
      var errorEl = document.getElementById('bundle-size-error');

      if (
        hasSizeOptions &&
        (!chosenSize || /choisis ta taille|choose your size/i.test(chosenSize))
      ) {
        return;
      }

      if (hasSizeOptions && errorEl) {
        errorEl.style.display = 'none';
      }

      var map = pack.querySelectorAll(
        '.jbb-variant-map [data-size], .jbb-variant-map [data-variant-id]:not([data-size])'
      );
      var variantId = null;
      var isAvailable = true;
      for (var i = 0; i < map.length; i++) {
        var span = map[i];
        if (span.dataset.size) {
          if (chosenSize && span.dataset.size === chosenSize) {
            variantId = span.dataset.variantId;
            isAvailable = String(span.dataset.available) === 'true';
            break;
          }
        } else if (span.dataset.variantId) {
          variantId = span.dataset.variantId;
          isAvailable = String(span.dataset.available) === 'true';
          break;
        }
      }
      if (variantId) {
        // Update hidden variant input
        idInput.value = variantId;
        idInput.dispatchEvent(new Event('input', { bubbles: true }));
        idInput.dispatchEvent(new Event('change', { bubbles: true }));

        // Get quantity selector ID for current pack
        var quantityInput = pack.querySelector('[data-bundle-quantity-input]');
        var quantitySelector = quantityInput ? quantityInput.id : null;

        // Update Add To Cart button dataset id used by add-to-cart component
        var atcBtn = form.querySelector('[js-add-to-cart-btn]');
        if (atcBtn) {
          try {
            atcBtn.dataset.id = String(variantId);
            if (quantitySelector) {
              atcBtn.dataset.quantitySelector = quantitySelector;
            }
          } catch (e) {}
        }

        // Try to update Just Pay Button (if present)
        var justBtn =
          form.querySelector('just-pay-button') ||
          document.querySelector('just-pay-button');

        if (justBtn) {
          try {
            justBtn.setAttribute('default_variant', String(variantId));
            justBtn.setAttribute('default_available', String(isAvailable));
            if (quantitySelector) {
              justBtn.setAttribute('quantity_selector', quantitySelector);
            }
          } catch (e) {}
        }
      }
    }

    root.addEventListener('click', function (e) {
      var packEl = e.target.closest && e.target.closest('variant-pack');
      if (!packEl) return;
      if (e.target.closest('.variant-pack-size-quantity')) return;
      selectPack(packEl);
    });

    root.addEventListener('change', function (e) {
      var radio = e.target.closest && e.target.closest('.jolly-bundle-radio');
      if (radio) {
        selectPack(radio.closest('variant-pack'));
      }
    });

    root.addEventListener('click', function (e) {
      var sizeLabel =
        e.target.closest && e.target.closest('[data-pack-size-option]');
      if (sizeLabel) {
        var input = root.querySelector('#' + sizeLabel.getAttribute('for'));
        var pack = sizeLabel.closest('variant-pack');
        if (input && !input.disabled) {
          input.checked = true;
          updateDropdownLabel(
            sizeLabel.closest('.bundle-dropdown'),
            sizeLabel.dataset.sizeValue
          );
          updateVariantFromPack(pack);
          checkSizeSelection(pack);
          var dd = sizeLabel.closest('.bundle-dropdown');
          if (dd) {
            var panel = dd.querySelector('[data-option-dropdown-items]');
            if (panel) panel.classList.add('jc-hidden');
          }
        }
      }
    });

    root.addEventListener('click', function (e) {
      var trigger =
        e.target.closest &&
        e.target.closest('.bundle-dropdown [data-option-dropdown-block]');
      if (trigger) {
        var dd = trigger.closest('.bundle-dropdown');
        if (!dd) return;
        var panel = dd.querySelector('[data-option-dropdown-items]');
        if (panel) panel.classList.toggle('jc-hidden');
        var openLists = root.querySelectorAll(
          '.bundle-dropdown [data-option-dropdown-items]:not(.jc-hidden)'
        );
        for (var i = 0; i < openLists.length; i++) {
          var parent = openLists[i].closest('.bundle-dropdown');
          if (parent !== dd) openLists[i].classList.add('jc-hidden');
        }
      }
    });

    document.addEventListener('click', function (e) {
      if (!root.contains(e.target)) {
        var lists = root.querySelectorAll(
          '.bundle-dropdown [data-option-dropdown-items]'
        );
        for (var i = 0; i < lists.length; i++)
          lists[i].classList.add('jc-hidden');
      }
    });

    // Handle quantity selector button clicks and input changes (only for bundle quantity selectors)
    root.addEventListener(
      'click',
      function (e) {
        var btn = e.target.closest && e.target.closest('.quantity__button');
        if (!btn) return;

        // Only handle clicks for bundle quantity selectors
        var qtySelector = btn.closest(
          'jolly-quantity-selector[data-bundle-quantity-selector]'
        );
        if (!qtySelector) return;

        var pack = btn.closest('variant-pack');
        if (!pack) return;

        var input = qtySelector.querySelector(
          'input[data-bundle-quantity-input]'
        );
        if (!input) return;

        // Prevent default button behavior but don't stop propagation
        // This allows the form to still work while we manage the quantity
        e.preventDefault();
        e.stopImmediatePropagation();

        var min = parseInt(input.min) || 1;
        var max = parseInt(input.max) || 9999;
        var currentValue = parseInt(input.value) || 1;

        if (btn.name === 'minus' && currentValue > min) {
          input.value = currentValue - 1;
        } else if (btn.name === 'plus' && currentValue < max) {
          input.value = currentValue + 1;
        }

        updateQuantityButtonStates(qtySelector);
        syncHiddenQuantityInput(pack);
      },
      true
    );

    root.addEventListener('input', function (e) {
      var input =
        e.target.closest &&
        e.target.closest('input[data-bundle-quantity-input]');
      if (!input) return;

      var qtySelector = input.closest('jolly-quantity-selector');
      if (qtySelector) {
        updateQuantityButtonStates(qtySelector);
        var pack = input.closest('variant-pack');
        if (pack) {
          syncHiddenQuantityInput(pack);
        }
      }
    });

    function updateQuantityButtonStates(qtySelector) {
      var input = qtySelector.querySelector(
        'input[data-bundle-quantity-input]'
      );
      var minusBtn = qtySelector.querySelector(
        ".quantity__button[name='minus']"
      );
      var plusBtn = qtySelector.querySelector(".quantity__button[name='plus']");

      if (!input) return;

      var min = parseInt(input.min) || 1;
      var max = parseInt(input.max) || 9999;
      var value = parseInt(input.value) || 1;

      if (minusBtn) {
        if (value <= min) {
          minusBtn.classList.add('disabled');
        } else {
          minusBtn.classList.remove('disabled');
        }
      }

      if (plusBtn) {
        if (value >= max) {
          plusBtn.classList.add('disabled');
        } else {
          plusBtn.classList.remove('disabled');
        }
      }
    }

    var first = currentPack();
    if (first) selectPack(first);

    // Add click handler for add-to-cart and just-pay buttons to show error
    function handleButtonClick(e) {
      var pack = currentPack();
      if (!pack) return;

      var hasSizeOptions = !!pack.querySelector('.jbb-variant-map [data-size]');
      if (!hasSizeOptions) return;

      var sizeLabel = pack.querySelector('[data-option-dropdown-value]');
      var chosenSize = sizeLabel ? (sizeLabel.textContent || '').trim() : '';

      if (
        !chosenSize ||
        /choisis ta taille|choose your size/i.test(chosenSize)
      ) {
        var errorEl = document.getElementById('bundle-size-error');
        if (errorEl) {
          errorEl.style.display = 'block';
          // Scroll to error message
          errorEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        e.preventDefault();
        e.stopPropagation();
      }
    }

    if (form) {
      var atcBtn = form.querySelector('.add-to-cart-btn');
      if (atcBtn) {
        atcBtn.addEventListener('click', handleButtonClick, true);
      }

      var justBtn =
        form.querySelector('just-pay-button') ||
        document.querySelector('just-pay-button');
      if (justBtn) {
        justBtn.addEventListener('click', handleButtonClick, true);
      }
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    var bundles = document.querySelectorAll('[id^="jollyBundles-"]');
    for (var i = 0; i < bundles.length; i++) {
      var el = bundles[i];
      var sectionId = el.id.replace('jollyBundles-', '');
      var productId = el.getAttribute('data-product-id');
      if (!productId) {
        var form = document.querySelector('[id^="product-form-"]');
        if (form) {
          var match = form.id.match(/product-form-(\d+)/);
          if (match) productId = match[1];
        }
      }
      initBundles(sectionId, productId);
    }
  });
})();
